import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const Email = forwardRef<SVGSVGElement, SvgIconProps>(
  function Email(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="M19.58 7.52c.07.22.12.45.12.68v7.9a1.7 1.7 0 01-1.65 1.74H5.33a1.7 1.7 0 01-1.66-1.74V8.2c0-.25.04-.46.12-.68l6.1 5.9a2.64 2.64 0 001.8.73 2.54 2.54 0 001.8-.72zm-1.52-1.06c.2 0 .4.04.56.1l-6.03 5.82a1.3 1.3 0 01-1.78 0L4.78 6.57c.17-.08.36-.11.56-.11z" />
      </SvgIcon>
    )
  },
)

export default Email
